export const validateTicketPrefixInput = (value) => {
  const letters = String(value ?? "").replace(/[^A-Za-z]/g, "");
  if (letters.length < 1) {
    return "Enter at least 1 letter (e.g. T or TCS).";
  }
  return null;
};

export const formatTicketPrefixPreview = (value) => {
  const letters = String(value ?? "").replace(/[^A-Za-z]/g, "").toUpperCase();
  if (letters.length < 1) return "";
  return `${letters}-001`;
};

export const sanitizeTicketPrefixInput = (value) =>
  String(value ?? "")
    .replace(/[^A-Za-z]/g, "")
    .slice(0, 3)
    .toUpperCase();
